import { Dropdown, DropDownProps } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

interface DropdownToolbarProps extends DropDownProps {
  children?: React.ReactNode;
}

const DropdownToolbarWrapper = styled.div``;

const DropdownToolbar = (props: DropdownToolbarProps) => {
  const {
    visible: visibleFromProps,
    trigger,
    children,
    onVisibleChange: onVisibleChangeFromProps,
    ...rest
  } = props;
  const [visible, setVisible] = React.useState(visibleFromProps);

  const onVisibleChange = (value: boolean) => {
    if (!('visible' in props)) {
      setVisible(value);
    }

    onVisibleChangeFromProps?.(value);
  };

  React.useEffect(() => {
    if ('visible' in props) {
      setVisible(visibleFromProps);
    }
  }, [props, visibleFromProps]);

  return (
    <DropdownToolbarWrapper
      onMouseDown={(event) => {
        event.preventDefault();
        onVisibleChange(!visible);
      }}
    >
      <Dropdown open={visible} trigger={[]} onVisibleChange={onVisibleChange} {...rest}>
        {children}
      </Dropdown>
    </DropdownToolbarWrapper>
  );
};

export default React.memo(DropdownToolbar);
